// @need-translate
import {useRouter} from 'next/router';
import {AppLinkFallbackType} from '../../../../../../applink/AppLinkFallbackType.enum';
import {pagewebUrlMatcher} from '../../../../../../applink/PagewebUrlMatcher.singleton';
import {requestContext} from '../../../../../../common/requestContext';
import {ContentNotSale} from '../../../../../../design-system/organisms/ContentNotSale/ContentNotSale';
import {ErrorArea} from '../../../../../../design-system/organisms/ErrorArea/ErrorArea';
import {NotAvailableOnWeb} from '../../../../../../design-system/organisms/NotAvailableOnWeb/NotAvailableOnWeb';
import {PagewebErrorType} from '../../../../../../errors/PagewebErrorType.enum';
import {SerializedPagewebError} from '../../../../../../errors/SerializedPagewebError.interface';
import {Maybe} from '../../../../../../graphql/generated/types';
import {ContentAgeAuthLimitCheckerHeadless} from '../../../../../common/headless/ContentAgeAuthLimitCheckerHeadless';

export function ViewerEntryErrorHandlerHeadless({
  seriesId,
  productId,
  error,
  retry,
}: {
  seriesId: number;
  productId: number;
  error: Maybe<SerializedPagewebError>;
  retry: VoidFunction;
}) {
  const router = useRouter();
  const {isMobile} = requestContext.requestInfo.display;
  /**
   * 다음과 같은 에러들을 뷰어 내에서 처리합니다.
   * - series/simple API의 데이터가 없는 경우 ContentNotSale 렌더링
   * - 웹 이용 불가 작품인 경우 NotAvailableOnWeb 렌더링
   * - 연령 인증이 필요한 작품이면 ContentAgeAuthLimitChecker 렌더링
   * - ready_to_use API가 실패했으며 판매중지 된 작품의 경우 ContentNotSale 렌더링
   */

  if (error?.type === PagewebErrorType.ContentNotSaleError) {
    return (
      <ContentNotSale
        onClickGoToHome={() => router.replace('/')}
        isMobile={isMobile}
      />
    );
  } else if (error?.type === PagewebErrorType.WebNotAccessibleError) {
    return (
      <NotAvailableOnWeb
        isMobile={isMobile}
        onClickAppLink={() =>
          window.location.assign(
            pagewebUrlMatcher.getCurrentAppLink({
              schemePrefixType: 'applink',
              fallbackType: AppLinkFallbackType.Store,
            })
          )
        }
      />
    );
  } else if (error?.type === PagewebErrorType.AgeNotGranted) {
    return (
      <ContentAgeAuthLimitCheckerHeadless
        seriesId={seriesId}
        productId={productId}
        location="viewer"
      />
    );
  } else if (error?.type === PagewebErrorType.NeedToBuyTicketError) {
    return (
      <ErrorArea isMobile={requestContext.requestInfo.display.isMobile}>
        <ErrorArea.Title>
          회차 구매 후<br />
          이용하실 수 있습니다
        </ErrorArea.Title>
        <ErrorArea.LabelButton onClick={retry}>
          구매 후 바로보기
        </ErrorArea.LabelButton>
      </ErrorArea>
    );
  } else {
    throw error;
  }
}
